import { Box, Typography, styled } from '@mui/material';
import Paper, { type PaperProps } from '@mui/material/Paper';
import { Link } from 'react-router-dom';

type PaperWrapperProps = {
  active: boolean;
  isDisabled: boolean;
} & PaperProps;

const getPaperBorderColor = (isDisabled: boolean, isActive: boolean, theme: any) => {
  if (isDisabled) {
    return theme.palette.gray.light;
  }
  if (isActive) {
    return theme.palette.success.dark;
  }
  return theme.palette.gray.light;
};

const getPaperBorderOnHover = (isDisabled: boolean, isActive: boolean, theme: any) => {
  if (isDisabled) {
    return theme.palette.gray.light;
  }
  if (isActive) {
    return theme.palette.success.dark;
  }
  return theme.palette.gray.main;
};

export const PaperWrapper = styled(Paper)<PaperWrapperProps>(({ active, isDisabled, theme }) => ({
  borderColor: getPaperBorderColor(isDisabled, active, theme),
  padding: '16px',
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  transition: 'border .15s ease-in',
  '&:hover': {
    borderColor: getPaperBorderOnHover(isDisabled, active, theme)
  }
}));

type LinkWrapperProp = {
  isDisabled: boolean;
};

export const LinkWrapper = styled(Link)<LinkWrapperProp>(({ isDisabled }) => ({
  cursor: isDisabled ? 'initial' : 'pointer',
  pointerEvents: isDisabled ? 'none' : 'auto'
}));

export const IntegrationNameWrapper = styled(Typography)(({ theme }: any) => ({
  textTransform: 'capitalize',
  fontWeight: 600,
  fontSize: theme.spacing(2),
  textAlign: 'center',
  wordBreak: 'break-word'
}));

export const LogoWrapper = styled('img')(() => ({
  height: 'auto',
  width: '100%',
  maxWidth: '180px',
  maxHeight: '100px'
}));

export const IntegrationStatusTagWrapper = styled(Box)(() => ({
  marginTop: '16px',
  display: 'inline-block',
  margin: '16px auto 0'
}));
